<template>
  <p class="lead">
    This Terms of Use is meant to help you understand what information we collect, why we collect it, and how you can
    update, manage, export, and delete your information.
  </p>
  <hr />
  <h3 id="user-acknowledgment-and-acceptance-of-terms">User’s Acknowledgment and Acceptance of Terms</h3>
  <p>
    Medical Licensing, LLC (referred to as “us” or “we”) provides the medicallicensing.com site and various related
    services (together referred to as this “Site”) subject to your compliance with all the terms, conditions, and
    notices contained or referenced herein (the “Terms of Use”), as well as any other written agreement between us (or
    your company). In addition, when using particular services or materials on this Site, users shall be subject to any
    posted guidelines or rules applicable to such services or materials that may contain terms and conditions in
    addition to those in these Terms of Use. All such guidelines or rules are hereby incorporated by reference into
    these Terms of Use.
  </p>
  <p>
    BY COMPLETING THE REGISTRATION PROCESS AND/OR USING THIS SITE, YOU AGREE TO BE BOUND BY THESE TERMS OF USE. IF YOU
    DO NOT WISH TO BE BOUND BY THESE TERMS OF USE, PLEASE EXIT THE SITE NOW. YOUR REMEDY FOR DISSATISFACTION WITH THIS
    SITE, OR ANY PRODUCTS, SERVICES, CONTENT, OR OTHER INFORMATION AVAILABLE ON OR THROUGH THIS SITE, IS TO STOP USING
    THE SITE AND/OR THOSE PARTICULAR PRODUCTS OR SERVICES. YOUR AGREEMENT WITH US REGARDING COMPLIANCE WITH THESE TERMS
    OF USE BECOMES EFFECTIVE IMMEDIATELY UPON COMMENCEMENT OF YOUR USE OF THIS SITE.
  </p>
  <p>
    These Terms of Use are effective as of April 1, 2021. We reserve the right to change these Terms of Use from time to
    time without notice to you. You acknowledge and agree that it is your responsibility to review this Site and these
    Terms of Use periodically and to be aware of any modifications. Your continued use of this Site after such
    modifications will constitute your acknowledgment of the modified Terms of Use and agreement to abide and be bound
    by the modified Terms of Use.
  </p>
  <p>
    As used in these Terms of Use, references to our “Affiliates” include our owners, subsidiaries, affiliated
    companies, officers, directors, suppliers, partners, sponsors, and advertisers, and includes (without limitation)
    all parties involved in creating, producing, and/or delivering this Site and/or its contents.
  </p>
  <h3 id="description-of-services">Description of Services</h3>
  <p>
    We make various services available on this Site including, but not limited to, providing users with application
    services for state medical licensing applications in the form of preparing the medical license application and
    documents required by the medical board, processing of verification requests, and corresponding with credential
    holders, medical board(s) and any other individuals or entities needed to make your medical license process is
    completed successfully (the “Services”). Fees for the various services are set out elsewhere in this Site. You are
    solely responsible for providing, at your own expense, all equipment necessary to use the Services, including a
    computer and modem; and your own Internet access (including payment of telephone service fees associated with such
    access).
  </p>
  <p>
    We reserve the sole right to either modify or discontinue this Site, including any features therein, at any time
    with or without notice to you. We shall not be liable to you or any third party should we exercise such right.
    Modifications may include, but are not limited to, changes in the pricing structure, the addition of fee-based
    services, or changes to limitations on allowable file sizes. Any new features that augment or enhance the
    then-current services on this Site shall also be subject to these Terms of Use.
  </p>
</template>

<script lang="ts" setup>
import { nanoid } from 'nanoid'

useCustomServerMeta({
  title: 'Terms of Use',
  description:
    'This Terms of Use is meant to help you understand what information we collect, why we collect it, and how you can update, manage, export, and delete your information.',
})

definePageMeta({
  layout: 'blog-owner',
  menu: [
    {
      id: nanoid(),
      name: 'User’s Acknowledgment and Acceptance of Terms',
      href: '#user-acknowledgment-and-acceptance-of-terms',
    },
    {
      id: nanoid(),
      name: 'Description of Services',
      href: '#description-of-services',
    },
  ],
})
</script>
